import frustumCull from '../frustumCull'

export default `
  uniform vec3 uColor1;
  uniform vec3 uColor2;
  uniform vec4 uProgress;
  uniform vec4 uRectData;


  varying vec2 vUv;
  varying vec3 vNormal2;

  float getFresnel(vec3 normal, float power) {
    vec3 viewDir = vec3(0.0, 0.0, 1.0);
    return 1.0 - pow(max(dot(viewDir, normal), 0.0), power);
  }

  void main() {
    float fresnel = getFresnel(vNormal2, mix(5.0, 1.0, smoothstep(0.0, 1.0, vUv.x)));
    vec3 color = mix(uColor1, uColor2, fresnel);
    color = mix(uColor2 + 0.3, color, smoothstep(0.3, 0.8, vUv.x));

    color = pow(color, vec3(1.0/2.2));

    float alpha = 1.0;
    alpha *= mix(1.0 - fresnel, 1.0, smoothstep(0.3, 1.0, vUv.x));
    alpha *= smoothstep(0.0, 1.1, vUv.x);
    alpha *= smoothstep(1.0 - uProgress.z, 2.5 - uProgress.z * 1.5, vUv.x);

    ${frustumCull}
    gl_FragColor = vec4(color, alpha);
  }
`
